// Define the base URL for the API

export const BASE_URL = 'https://corporate101.sentinel.lk/api/';
// export const BASE_URL = 'http://localhost:5050/api/';
// export const BASE_URL = 'http://172.105.44.186/api/';
// Define API endpoints
export const ENDPOINTS = {
  // Site Management
  REGISTER_SITE: 'sites/office-boundary/',
  GET_ALL_SITES: 'sites/api/boundaries/',
  DELETE_SITE: 'sites/api/boundaries/:siteId/delete/',

  // Authentication
  LOGIN: 'users/login', 

  // Attendance
  GET_ATTENDANCE_BY_DATE: 'attendance/attendance-by-date/',
  UPDATE_ATTENDANCE: 'attendance/update-attendance/',      
  GET_TODAY_ATTENDANCE: 'attendance/today/',
  GET_ATTENDANCE_REPORT: 'attendance/report/',
  GET_ATTENDANCE_ANALYTICS: 'attendance/analytics/',
  EDIT_TIMES: 'attendance/edit-times/',
  CHECKIN: 'attendance/checkin/',
  CHECKOUT: 'attendance/checkout/',
  // Attendance corrections
  GET_ATTENDANCE_CORRECTIONS: 'attendance-corrections/',
  UPDATE_ATTENDANCE_CORRECTION: 'attendance-corrections/:id',

  // User Management
  GET_ALL_USERS_BY_COMPANY: 'users/:company_id',
  
  REGISTER_USER: 'users/register',
  DELETE_USER: 'users/:userId/delete/',
  UPDATE_USER: 'users/:userId/update/',

  // Company Management
  GET_COMPANY_LOGO: 'company/logo/:company_id',
  COMPANY_REGISTRATION: 'company/register/',

  // Department Management
  CREATE_DEPARTMENT: 'departments/:company_id/create',
  GET_ALL_DEPARTMENTS: 'departments/:company_id',
  UPDATE_DEPARTMENT: 'departments/:department_id/update',
  DELETE_DEPARTMENT: 'departments/:department_id/delete',
  ADD_EMPLOYEES_TO_DEPARTMENT: 'departments/:department_id/users',
  GET_DEPARTMENT_EMPLOYEES: 'departments/:department_id/employees',
  REMOVE_DEPARTMENT_EMPLOYEES: 'departments/:department_id/deleteusers',
  
  // Leaves
  GET_COMPANY_LEAVES: 'leaves/company',
};

// You can also export helper functions if needed, e.g., to construct full URLs
export const getFullUrl = (endpoint) => `${BASE_URL}${endpoint}`;
